import { render, staticRenderFns } from "./clueManage.vue?vue&type=template&id=bb497a10&scoped=true&"
import script from "./clueManage.vue?vue&type=script&lang=js&"
export * from "./clueManage.vue?vue&type=script&lang=js&"
import style0 from "./clueManage.vue?vue&type=style&index=0&id=bb497a10&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb497a10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb497a10')) {
      api.createRecord('bb497a10', component.options)
    } else {
      api.reload('bb497a10', component.options)
    }
    module.hot.accept("./clueManage.vue?vue&type=template&id=bb497a10&scoped=true&", function () {
      api.rerender('bb497a10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/clue/clueManage/clueManage.vue"
export default component.exports